import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CommonService } from '../services/common.service';

@Component({
  selector: 'app-apropos-ecorec',
  templateUrl: './apropos-ecorec.component.html',
  styleUrls: ['./apropos-ecorec.component.css']
})
export class AproposEcorecComponent implements OnInit {

  objetInfo: any = {};
  constructor(public common: CommonService) { }

  ngOnInit() {
    this.objetInfo = this.common.objetApropos || {};
  }

}
